import React from "react";
import { Link } from "react-router-dom";
import Button from "../Components/Button";
import Input from "../Components/Input";

const ForgotComponent = ({ handleInput, forgot, records, errors }) => {
  const handleKey = (event) => {
    if (event.key === "Enter") {
      forgot();
    }
    return;
  };
  return (
    <div className="bg-gray-200 p-4 w-full md:w-10/12 lg:w-1/2 h-auto rounded shadow-md mx-auto">
      <div className="w-full">
        <h1 className="uppercase text-4xl">ppdb reset password</h1>
      </div>
      <div className="w-full mt-4">
        <Input
          type="email"
          name="email"
          label="E-Mail"
          value={records.email ?? ""}
          onChange={(e) => handleInput(e)}
          onKeyDown={handleKey}
          errors={errors}
        />
      </div>
      <div className="flex flex-col md:flex-row justify-between mt-8 gap-4">
        <Link to="/">
          <Button color="bg-orange-500 w-full">login</Button>
        </Link>
        <Button onClick={() => forgot()}>kirim e-mail reset password</Button>
      </div>
    </div>
  );
};

export default ForgotComponent;
